/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */

/**
 * The contract type
 */
export type ContractTypeParameter =
  (typeof ContractTypeParameter)[keyof typeof ContractTypeParameter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractTypeParameter = {
  distribution: "distribution",
  neighbouring_rights: "neighbouring_rights",
} as const;
